import { API_BASE_URL } from '../services/api';

const isStaticAssetPath = (value: string): boolean =>
  value.startsWith('/uploads/')
  || value.startsWith('/asset/')
  || value.startsWith('/public/asset/');

export const resolveReportVideoUrl = (rawUrl: string): string => {
  const url = rawUrl?.trim();
  if (!url) return url;

  const token = typeof window !== 'undefined' ? sessionStorage.getItem('shareToken') : null;
  const appendToken = (absoluteUrl: string): string => {
    if (!token || typeof window === 'undefined') return absoluteUrl;
    try {
      const built = new URL(absoluteUrl, window.location.origin);
      if (isStaticAssetPath(built.pathname)) return built.toString();
      built.searchParams.set('token', token);
      return built.toString();
    } catch {
      if (isStaticAssetPath(absoluteUrl)) return absoluteUrl;
      const separator = absoluteUrl.includes('?') ? '&' : '?';
      return `${absoluteUrl}${separator}token=${encodeURIComponent(token)}`;
    }
  };

  if (/^https?:\/\//i.test(url)) return appendToken(url);

  const normalizedPath = `/${url.replace(/^\/+/, '')}`;
  const isStaticAsset = isStaticAssetPath(normalizedPath);
  let base = isStaticAsset ? API_BASE_URL.replace(/\/api\/?$/i, '') : API_BASE_URL;
  if (!base) base = '/';

  const sanitizedBase = base.replace(/\/+$/, '');
  let pathSegment = normalizedPath;
  if (!isStaticAsset && /\/api$/i.test(sanitizedBase) && pathSegment.startsWith('/api/')) {
    pathSegment = pathSegment.substring(4);
    if (!pathSegment.startsWith('/')) pathSegment = `/${pathSegment}`;
  }

  const absolute = `${sanitizedBase}${pathSegment}`;
  return isStaticAsset ? absolute : appendToken(absolute);
};
